define('helperContent-getQuizMap',['content--get-entity.es'], function(getEntityES) {
    'use strict';

    var getEntity = getEntityES.default;

    var getQuizMap = function(trainingEntities) {
        var quizMap = [];

        if (Array.isArray(trainingEntities) && trainingEntities.length) {
            var i = 0,
                id = '',
                len = 0,
                arr = [],
                item = null,
                isQuizChild = function(ID, entities) {
                    for (var i = 0; i < entities.length; i++) {
                        if (ID === entities[i].contentEntityId) {
                            return true;
                        }
                    }

                    return false;
                },
                getNextID = function(arr, indx) {
                    var no = indx + 1 || 0;

                    if (arr && Array.isArray(arr) && arr.length > no) {
                        return arr[no].contentEntityId;
                    }

                    return '';
                },
                objInArray = function(obj, arr) {
                    var i = (arr && Array.isArray(arr)) ? arr.length : 0;

                    while(i--) {
                        if (arr[i].id === obj.id && arr[i].value === obj.value ) {
                            return true;
                        }
                    }

                    return false;
                };

            if (trainingEntities[0].hasOwnProperty('contentEntityId') && trainingEntities[0].contentEntityId) {
                id = trainingEntities[0].contentEntityId;

                (function f(entities, id) {
                    var nextID = '',
                        entity = getEntity(id, trainingEntities),
                        content = (entity && entity.hasOwnProperty('contentEntity') && entity.contentEntity)

                    if (content) {

                        if (content.naviTargetId) {

                            item = {
                                id: id,
                                value: content.naviTargetId
                            };

                            if (!objInArray(item, arr)) {
                                arr.push(item);
                                f(entities, content.naviTargetId);
                            }

                        } else {

                            if (entities.indexOf(entity) < entities.length) {

                                nextID = getNextID(entities, entities.indexOf(entity));

                                item = {
                                    id: id,
                                    value: nextID
                                };

                                if (!objInArray(item, arr)) {
                                    arr.push(item);
                                    f(entities, nextID);
                                }

                            }

                        }

                    }

                })(trainingEntities, id);
            }

            len = arr.length;
            for( ; i < len; i++) {
                if (quizMap.indexOf(arr[i].id) === -1 && isQuizChild(arr[i].id, trainingEntities)) {
                    quizMap.push(arr[i].id);
                }
            }

        }

        return quizMap;
    };

    return getQuizMap;

});

